export default {
  namespaced: true,
  state() {
    return {
      currencyOid: '',
      currencyCredit: 0,
    }
  },
  mutations: {
    setCurrencyOid(state, value) {
      state.currencyOid = value
    },
    setCurrencyCredit(state, value) {
      state.currencyCredit = value
    },
  },
  actions: {
    saveCurrency({ commit }, { oid, credit }) {
      commit('setCurrencyOid', oid)
      commit('setCurrencyCredit', credit)
    },
  },
  getters: {
    currencyOid(state) {
      return state.currencyOid
    },
    currencyCredit(state) {
      return state.currencyCredit
    },
  },
}
